import { colors, createStyles, Theme } from '@material-ui/core';

export const styles = (theme: Theme) =>
  createStyles({
    formWithOutToolbar: {
      '& .MuiToolbar-gutters': {
        paddingLeft: theme.spacing(0),
        display: 'none'
      }
    },
    title: {
      '& .MuiTypography-h6': {
        fontSize: '1.2rem',
        fontWeight: 400,
        lineHeight: 1.334,
        letterSpacing: '0em'
      }
    }
  });
